module.exports = __webpack_public_path__ + "img/abstract-shapes-16.a16b97e6.svg";